import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Content } from "./style";
import './style.css';

import Sidebar from "./sidebar.jsx";
import NewHeader from "../header/new-header.js";

function Layout(props) {
  const headerRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [currentOpenedTab, setCurrentOpenedTab] = useState('');
  const [makeBlur, setMakeBlur] = useState(false);

  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [tab, setTab] = useState({ parent: '', child: '' });
  const [show, setShow] = useState(false);
  const [linkToOpen, setLinkToOpen] = useState('');
  const [currentUrl, setCurrentUrl] = useState('');
  const [currentSingleTab, setCurrentSingleTab] = useState('');
  const [showTrialPopup, setShowTrialPopup] = useState('');
  const [userDropdown, setUserDropdown] = useState();

  const handleMenuClick = (path) => {
    setActiveItem(path);
    resetAndNavigate(path);
  };

  const { currentUser: user } = useSelector((state) => state?.auth || {});

  const isOwner = user?.email == "mike@opulent.com";
  const isAdmin = user?.role_id == 1 || user?.role_id == 3;
  const isWarehouseWorker = user?.warehouse_manager_id;
  const isWorker = user?.role_id == 5;
  const isNotSpecialUser = user?.email != "test@sales.support.com";

  const path = window?.location?.pathname;
  const isFBMPages = path.includes('warehouse-location') || path.includes('location-names') || path.includes('locations-history') || path.includes('locations') || path.includes('fba-inbound');

  useEffect(() => {
    const { pathname } = window.location;
    if (pathname.includes("/affiliate")) {
      setCurrentOpenedTab('Affiliate');
      setCurrentUrl(pathname);
      setCurrentSingleTab('');
    }
    else if (['/transport-plans'].includes(pathname)) {
      setCurrentOpenedTab('FBA');
      setCurrentUrl(pathname);
      setCurrentSingleTab('');
    }
    else if (['/users', '/account', '/billing'].includes(pathname)) {
      setCurrentOpenedTab('Settings');
      setCurrentUrl(pathname);
      setCurrentSingleTab('');
    }
    else if (['/invoices', '/user-invoices', '/subscription-invoices',
      '/two-step-master-invoices', '/two-step-invoices', '/invoices/settings']
      .includes(pathname)) {
      setCurrentOpenedTab('Invoices');
      setCurrentUrl(pathname);
      setCurrentSingleTab('');
    }
    else if (pathname === '/admin/user') {
      setCurrentSingleTab('Admin');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/vendors') {
      setCurrentSingleTab('Vendors');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/sourcing') {
      setCurrentSingleTab('Sourcing');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/employees') {
      setCurrentSingleTab('Employees');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/catalog-jobs') {
      setCurrentSingleTab('Catalog');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/products') {
      setCurrentSingleTab('Inventory');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/sales') {
      setCurrentSingleTab('Sales');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/warehouse-location') {
      setCurrentSingleTab('InternalStorage');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/home') {
      setCurrentSingleTab('MobileScreen');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
    else if (pathname === '/locations') {
      setCurrentSingleTab('Locations');
      setCurrentOpenedTab('');
      setCurrentUrl('');
    }
  }, [window.location.pathname, collapsed])

  useEffect(() => {
    if (user && user?.role?.name !== 'Worker') {
      setShowTrialPopup(!user?.card_added);
    }
  }, [user]);

  useEffect(() => {
    handleSetTab(window.location.pathname);
  }, [window.location.pathname]);

  const handleContextMenu = useCallback(
    (event, link) => {
      event.preventDefault();
      setLinkToOpen(link);
      setAnchorPoint({ x: event.pageX, y: event.pageY });
      setShow(true);
    },
    [setAnchorPoint]
  );

  const resetAndNavigate = async (link, reducers) => {
    if (window.location.pathname !== link) {
      await dispatch({ type: 'RESET_APP', reducers });
      navigate(link);
    }
  }

  const { is_public_warehouse, is_affiliate_manager_worker, is_public_warehouse_worker, is_affiliate_manager } = user || {};
  const allowMobileScreens = is_public_warehouse || is_public_warehouse_worker || is_affiliate_manager || is_affiliate_manager_worker;
  const allowRemovalPages = is_public_warehouse || is_affiliate_manager;

  const handleSetTab = (path) => {
    if (path === '/sales') setTab({ parent: '', child: 'Dashboard' });

    else if (path === '/catalog-jobs') setTab({ parent: '', child: 'Catalog Analyzer' });

    else if (path === '/inventory/sku') setTab({ parent: 'Inventory', child: 'SKU' });
    else if (path === '/inventory/products') setTab({ parent: 'Inventory', child: 'Products' });
    else if (path === '/inventory/vendor') setTab({ parent: 'Inventory', child: 'Vendor Items' });

    else if (path === '/vendors') setTab({ parent: 'Purchasing', child: 'Vendor CRM' });
    else if (path === '/po-history') setTab({ parent: 'Purchasing', child: 'Purchase Orders' });
    else if (path === '/sourcing') setTab({ parent: 'Sourcing', child: 'Catalog Analyzer' });
    else if (path === '/database') setTab({ parent: 'Sourcing', child: 'Database' });

    else if (path === '/employees') setTab({ parent: '', child: 'Employees' });

    else if (path.includes('/work-order')) setTab({ parent: 'Logistics', child: 'Work Orders' });

    else if (path === '/user-invoices') setTab({ parent: '', child: 'Shipment Invoice' });

    else if (path === '/account') setTab({ parent: 'Settings', child: 'Account' });
    else if (path === '/users') setTab({ parent: 'Settings', child: 'Users' });
    else if (path === '/billing') setTab({ parent: 'Settings', child: 'Billing' });

    // Warehouse Routes
    else if (path === '/po-warehouse') setTab({ parent: 'Logistics', child: 'Purchase Orders' });
    else if (path === '/warehouse-location') setTab({ parent: 'Logistics', child: 'Locations' });
    else if (path === '/warehouse-work-orders') setTab({ parent: 'Logistics', child: 'Work Orders' });
  };

  return (
    <>
      <NewHeader
      setCollapsed={setCollapsed}
      collapsed={collapsed}
        tab={tab}
      />

      {/* <div className="d-flex sidebar-collapsed">
        {show && (
          <ul
            className="context-menu"
            style={{
              top: anchorPoint.y,
              left: anchorPoint.x,
            }}
          >
            <li className="context-menu-item" onClick={() => {
              window.open(linkToOpen, '_blank');
              setShow(false);
            }}
            >
              Open Link In New Tab
            </li>
            <li className="context-menu-item" onClick={() => {
              window.open(linkToOpen, '_blank', 'location=yes,height=650,width=1400,scrollbars=yes,status=yes');
              setShow(false);
            }}
            >
              Open Link In New Window
            </li>
          </ul>
        )} */}
      {/* <ProSidebar collapsed={collapsed} onMouseOver={() => setCollapsed(false)}>
          <Menu iconShape="square"> */}
      {/* <MenuItem
              active={currentUrl === "/dashboard"}
              className="no-border"
              icon={<span className="icon-admin"></span>}
              onClick={() => resetAndNavigate("/dashboard", ['dashboard'])}
            >
              Dashboard
            </MenuItem> */}

      {/* {isOwner && (
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/admin/user`)}
                active={currentSingleTab === "Admin"}
                className="no-border"
                icon={<span className="icon-admin"></span>}
                onClick={() => resetAndNavigate("/admin/user", ["adminUsers"])}
              >
                Admin Users
              </MenuItem>
            )} */}

      {/* {(user?.is_affiliate_manager || isOwner) && (
              <SubMenu
                title="Affiliate"
                icon={<span className="icon-affliate"></span>}
                open={currentOpenedTab === 'Affiliate'}
                onClick={() => {
                  if (currentOpenedTab === 'Affiliate') {
                    setCurrentOpenedTab('')
                  } else {
                    setCurrentOpenedTab('Affiliate')
                  }
                }}
              >
                <MenuItem
                  onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/affiliate`)}
                  active={currentUrl === "/affiliate"}
                  className="no-border"
                  onClick={() => resetAndNavigate("/affiliate", ['affiliate'])}
                >
                  User
                </MenuItem>
                {user?.master_shipment_enabled && (
                  <MenuItem
                    onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/affiliate/account-settings`)}
                    active={currentUrl === "/affiliate/account-settings"}
                    className="no-border"
                    onClick={() => resetAndNavigate("/affiliate/account-settings", ['affiliateAccountSettings'])}
                  >
                    Settings
                  </MenuItem>
                )}
              </SubMenu>
            )} */}

      {/* {!isWarehouseWorker && !isWorker && (
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/vendors`)}
                active={currentSingleTab === "Vendors"}
                className="no-border"
                icon={<span className="icon-vendor_crm"></span>}
                onClick={() => resetAndNavigate("/vendors", ['vendors'])}
              >
                Vendors CRM
              </MenuItem>
            )} */}

      {/* {isAdmin && (
              <MenuItem
                active={currentUrl === "/warehouse-vendors"}
                className="no-border"
                icon={<span className="icon-warehouse"></span>}
                onClick={() => resetAndNavigate("/warehouse-vendors", [])}
              >
                // <Link to="/warehouse-vendors" />
                Warehouse Vendor
              </MenuItem>
            )} */}

      {/* <MenuItem
              onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/catalog-jobs`)}
              active={currentSingleTab === "Catalog"}
              className="no-border"
              icon={<span className="icon-catalog"></span>}
              onClick={() => resetAndNavigate("/catalog-jobs", ['catalogJobs', 'processedCatalogs'])}
            >
              Catalog Analyzer
            </MenuItem>

            <MenuItem
              onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/products`)}
              active={currentSingleTab === "Inventory"}
              className="no-border"
              icon={<span className="icon-inventory"></span>}
              onClick={() => resetAndNavigate("/products", ['products', 'Products', 'pendingPoIndices'])}
            >
              Inventory Tab
            </MenuItem>

            {
              allowMobileScreens &&
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/warehouse-location`)}
                active={currentSingleTab === "InternalStorage"}
                className="no-border"
                icon={<span className="icon-fbm"></span>}
                onClick={() => resetAndNavigate("/warehouse-location", ['internalStorage'])}
              >
                Locations
              </MenuItem>
            } */}

      {/* <MenuItem
              onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/warehouse-location`)}
              active={currentSingleTab === "Locations"}
              className="no-border"
              icon={<span className="icon-fbm"></span>}
              onClick={() => resetAndNavigate("/locations", ['internalStorage'])}
            >
              Internal Storage
            </MenuItem> */}

      {/* {allowMobileScreens &&
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/home`)}
                active={currentSingleTab === "MobileScreen"}
                className="no-border"
                icon={<span className="icon-catalog"></span>}
                onClick={() => resetAndNavigate("/home", ['internalStorage'])}
              >
                Scan Locations
              </MenuItem>
            }
            */}

      {/* {!isWarehouseWorker && !isWorker && (
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/sales`)}
                active={currentSingleTab === "Sales"}
                className="no-border"
                icon={<span className="icon-sales_support"></span>}
                onClick={() => resetAndNavigate("/sales", ['sales'])}
              >
                Sales Report
              </MenuItem>
            )} */}

      {/* <SubMenu
              title="FBA Inbound [New]"
              icon={<span className="icon-fbaInbound"></span>}
              open={currentOpenedTab === 'FBA'}
              onClick={() => {
                if (currentOpenedTab === 'FBA') {
                  setCurrentOpenedTab('')
                } else {
                  setCurrentOpenedTab('FBA')
                }
              }}
            >
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/transport-plans`)}
                active={currentUrl === "/transport-plans"}
                className="no-border"
                onClick={() => resetAndNavigate("/transport-plans", ['shipments'])}
              >
                All Shipments
              </MenuItem>
            </SubMenu> */}

      {/* <SubMenu
              title="FBA Inbound"
              icon={<span className="icon-fbaInbound"></span>}
              open={currentOpenedTab === 'FBA'}
              onClick={() => {
                if (currentOpenedTab === 'FBA') {
                  setCurrentOpenedTab('')
                } else {
                  setCurrentOpenedTab('FBA')
                }
              }}
            >
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/transport-plans`)}
                active={currentUrl === "/transport-plans"}
                className="no-border"
                onClick={() => resetAndNavigate("/transport-plans", ['shipments'])}
              >
                All Shipments
              </MenuItem>
            </SubMenu> */}

      {/* 
            <SubMenu
              title="Settings"
              icon={<span className="icon-setting"></span>}
              open={currentOpenedTab === 'Settings'}
              onClick={() => {
                if (currentOpenedTab === 'Settings') {
                  setCurrentOpenedTab('')
                } else {
                  setCurrentOpenedTab('Settings')
                }
              }}
            >
              {!isWorker && (
                <MenuItem
                  onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/users`)}
                  active={currentUrl === "/users"}
                  className="no-border"
                  onClick={() => resetAndNavigate("/users", ['workers'])}
                >
                  Users
                </MenuItem>
              )}
              <MenuItem
                onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/account`)}
                active={currentUrl === "/account"}
                className="no-border"
                onClick={() => resetAndNavigate("/account", ['account'])}
              >
                Account
              </MenuItem>
              {!isWorker && (
                <MenuItem
                  onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/payments`)}
                  active={currentUrl === "/payments"}
                  className="no-border"
                  onClick={() => resetAndNavigate("/payments", ['payment', 'affiliateAccountSettings'])}
                >
                  Payment
                </MenuItem>
              )}
            </SubMenu>

            {!isWarehouseWorker && !isWorker && (
              <SubMenu
                title="Invoices"
                icon={<span className="icon-invoices"></span>}
                open={currentOpenedTab === 'Invoices'}
                onClick={() => {
                  if (currentOpenedTab === 'Invoices') {
                    setCurrentOpenedTab('')
                  } else {
                    setCurrentOpenedTab('Invoices')
                  }
                }}
              > */}
      {/* {isAdmin &&
                  <MenuItem active={currentUrl === "/invoices"} className="no-border">
                    <Link to="/invoices" />Warehouse
                  </MenuItem>
                } */}
      {/* {(isAdmin || user?.master_shipment_enabled) && (
                  <MenuItem
                    onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/invoices`)}
                    active={currentUrl === "/invoices"}
                    className="no-border"
                    onClick={() => resetAndNavigate("/invoices", ['customerInvoices', 'affiliateAccountSettings'])}
                  >
                    Shipment [Master]
                  </MenuItem>
                )} */}
      {/* {isNotSpecialUser && ( */}
      {/* <MenuItem
                  onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/user-invoices`)}
                  active={currentUrl === "/user-invoices"}
                  className="no-border"
                  onClick={() => resetAndNavigate("/user-invoices", ['userInvoices', 'affiliateAccountSettings'])}
                >
                  Shipment
                </MenuItem> */}
      {/* )} */}
      {/* <MenuItem
                  onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/subscription-invoices`)}
                  active={currentUrl === "/subscription-invoices"}
                  className="no-border"
                  onClick={() => resetAndNavigate("/subscription-invoices", ['subscriptionInvoices'])}
                >
                  Subscription
                </MenuItem>
                {isAdmin && (
                  <MenuItem
                    onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/two-step-master-invoices`)}
                    active={currentUrl === "/two-step-master-invoices"}
                    className="no-border"
                    onClick={() => resetAndNavigate("/two-step-master-invoices", ['twoStepInvoices'])}
                  >
                    Two Steps [Master]
                  </MenuItem>
                )} */}
      {/* {isNotSpecialUser && ( */}
      {/* <MenuItem
                  onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/two-step-invoices`)}
                  active={currentUrl === "/two-step-invoices"}
                  className="no-border"
                  onClick={() => resetAndNavigate("/two-step-invoices", ['twoStepInvoices'])}
                >
                  Two Steps
                </MenuItem> */}
      {/* )} */}
      {/* {isAdmin && (
                  <MenuItem
                    onContextMenu={(event) => handleContextMenu(event, `${window.location.origin}/invoices/settings`)}
                    active={currentUrl === "/invoices/settings"}
                    className="no-border"
                    onClick={() => resetAndNavigate("/invoices/settings", [])}
                  >
                    Settings
                  </MenuItem>
                )}
              </SubMenu>
            )}
          </Menu>
        </ProSidebar> */}
      <div style={{ height: `calc(100vh - ${user.role_id === 2 ? '73px' : '49px'})` }} className="d-flex w-100">
        <Sidebar
          handleSetTab={handleSetTab}
          selectedTab={tab}
          collapsed={collapsed}
        />
        <Content
          //  style={{ height: "calc(100vh)" }} 
          // onMouseOver={() => {
          //   setCollapsed(true);
          //   setShow(false);
          // }}
          // onClick={() => headerRef.current.closeMenu()}
          makeBlur={makeBlur}
        >

          {isFBMPages ?
            (
              <div
                style={{ height: `calc(100vh - ${path.includes("fba-inbound") ? "108px" : "85px"})` }}
                className={collapsed ? "collapsed" : "collapsed-none"}
              >
                {props.currentComponent}
              </div>
            ) :
            (
              <div
                style={{ maxHeight: "calc(100vh - 86px)" }}
                className={collapsed ? "collapsed" : "collapsed-none"}
              >
                {props.currentComponent}
              </div>
            )
          }
        </Content>
      </div>
      {/* </div> */}
      {/* {
        showTrialPopup ? <Box position="absolute" top="2px" left="35%">
          <TrailPopover
            trialEndDate={user?.trial_end_date}
            setShowTrialPopup={setShowTrialPopup}
            onClick={() => {
              resetAndNavigate("/payments", ['payment', 'affiliateAccountSettings'])
              setShowTrialPopup(false);
            }}
          />
        </Box> : ""
      } */}
    </>
  );
}

export default Layout;
